<template v-slot:default="{ isActive }">
  <v-dialog
    v-model="dialog"
    width="60rem"
    class="layer-popup"
    scrollable
  >
    <v-card>
      <!--content-->
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="pop-title">{{ popTitle }}</div>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click.stop="dialog = false"
        ></v-btn>
      </v-card-title>
      <!--content-->
      <v-card-text>
        <div class="qr-group">
          <p>{{clientName+' / '+companyName}}<br>{{monitoringTitle}}</p>
          <img :src="qrcode" alt="" :id="'print-div'">
        </div>
      </v-card-text>
      <!--버튼-->
      <v-card-actions class="d-flex justify-end"><!--pop-bottom-bg-->
        <c-btn02 :btnText="t('message.fileSave')" @click="onClickPrint('f')"/>
        <c-btn01 :btnText="t('message.print')" @click="onClickPrint('p')"/>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import {toDataURL} from 'qrcode';
import html2canvas from 'html2canvas';
import printJS from 'print-js';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//define
const props = defineProps(['popTitle'])
const emit = defineEmits(['close'])
const dialog = defineModel()

//bind
const qrcode = ref<string>()
const monitoringTitle = ref('')
const clientName = ref(localStorage.getItem('clientName'))
const companyName = ref(localStorage.getItem('companyName'))

const generateQR = async (url: string) => {
  qrcode.value = await toDataURL(url)
}

onMounted(async () => {
})

onUpdated(async () => {
  if(dialog.value) {
    const url = 'https://impactus.co.kr/monitoring/1/' + storeRef.popupIdx.value
    await generateQR(url)
    monitoringTitle.value = storeRef.popupTitle.value
  }
})

//function
function onClickPrint(type){
  if(type == 'f'){
    handleOnCoverCanvas()
  }
  else if(type == 'p'){
    printJS({
      printable: 'print-div',
      type: 'html',
      targetStyles: ['*'],
      maxWidth: '100%',
    } as any);
  }
}

const handleOnCoverCanvas = async () => {
  const paper = document.querySelector("#print-div");

  if (paper !== null && paper instanceof HTMLElement) {
    const canvas = await html2canvas(paper);
    const imageFile = canvas.toDataURL("image/png", 1.5);

    let a = document.createElement('a');
    a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
    a.download = `qr code_${clientName.value}_${companyName.value}_${monitoringTitle.value}.jpeg`;
    a.click()
    //return imageFile;
  }
};
</script>


<style lang="scss">

</style>
